import CheckIcon from '@mui/icons-material/Check';
import DSModal from '../../../design-system/DSModal';
import DSBox from '../../../design-system/DSBox';
import DSPrimaryButton from '../../../design-system/DSPrimaryButton';
import { DSTypography } from '../../../design-system/Typography';
import { KLYDO_WHITE, TEXT_SECONDARY } from '../../../consts/colors';

/**
 * What the artist just did, in the words of the destination they picked.
 *
 * This replaced the "Submitted for review" snackbar that used to live in
 * `useRequestPublicationMutation`. The snackbar could not serve the Collection
 * branch at all — that branch submits nothing, so there is no mutation to hang a
 * toast off — and it could not say WHEN a scheduled klydo goes live.
 */
export type PublishSuccess = {
  title: string;
  caption: string;
};

type PublishSuccessModalProps = {
  success: PublishSuccess | null;
  onClose: () => void;
};

const PublishSuccessModal = ({
  success,
  onClose,
}: PublishSuccessModalProps) => {
  return (
    <DSModal open={!!success} onClose={onClose}>
      <DSBox
        sx={{
          width: { xs: '90vw', sm: 420 },
          padding: '34px 34px 28px',
          textAlign: 'center',
        }}
      >
        <DSBox
          sx={{
            width: 56,
            height: 56,
            margin: '0 auto',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: KLYDO_WHITE,
            background: 'rgba(255, 255, 255, 0.08)',
          }}
        >
          <CheckIcon sx={{ fontSize: 26 }} />
        </DSBox>

        <DSTypography
          sx={{
            fontSize: 20,
            fontWeight: 700,
            lineHeight: 1.25,
            marginTop: '18px',
          }}
        >
          {success?.title}
        </DSTypography>
        <DSTypography
          sx={{
            fontSize: 14,
            fontWeight: 500,
            lineHeight: 1.6,
            color: TEXT_SECONDARY,
            marginTop: '10px',
          }}
        >
          {success?.caption}
        </DSTypography>

        <DSPrimaryButton
          onClick={onClose}
          fullWidth
          sx={{
            marginTop: '24px',
            padding: '14px',
            fontSize: 15,
            fontWeight: 700,
          }}
        >
          Done
        </DSPrimaryButton>
      </DSBox>
    </DSModal>
  );
};

export default PublishSuccessModal;
